export default __webpack_public_path__ + "static/media/travoltaNotFound.c9d582db.gif";